import React from 'react';

import './presets.scss';
import { getClass } from '../../../utils/component-helpers';

export default (props) => {
	const options = (
		<div className="options">
			<button className="apply-btn" onClick={() => props.apply()}>
				Apply
			</button>
			<button className="cancel-btn" onClick={() => props.cancel()}>
				Cancel
			</button>
		</div>
	);

	const presetRanges = props.presetRanges;
	const datePresets = (
		<div className="date-presets">
			{
				Object.keys(presetRanges).map((key) => {
					return (
						<button
							key={key}
							className={getClass('preset', {
								'selected': presetRanges[key].selected,
							})}
							onClick={() => props.presetClicked(key)}>
							{presetRanges[key].label}
						</button>
					);
				})
			}
		</div>
	);

	return (
		<div className="date-picker-presets">
			{options}
			{datePresets}
		</div>
	);
};
